import type { Matrix } from "#public"

/** `inner` then `outer` — the matrix mapping a point of the inner space all the
 * way out. Composing a child group's matrix with its parent's is exactly this,
 * in that order.
 *
 * Both sides must already be in the same space: `a`–`d` are ratios, so the
 * product is a ratio, and the translation stays in `T`. */
export const MatrixCompose = <T extends number>(
  [a1, b1, c1, d1, e1, f1]: Matrix<T>,
  [a2, b2, c2, d2, e2, f2]: Matrix<T>
): Matrix<T> => [
  a1 * a2 + b1 * c2,
  a1 * b2 + b1 * d2,
  c1 * a2 + d1 * c2,
  c1 * b2 + d1 * d2,
  (e1 * a2 + f1 * c2 + e2) as T,
  (e1 * b2 + f1 * d2 + f2) as T,
]
